import { forwardRef } from 'react';
import { GoogleMapsProvider } from '../../../components/GoogleMapsProvider';
import Locations from './Locations';

const LocationMap = forwardRef(({ onSuccess }, ref) => {
  return (
    <>
      <GoogleMapsProvider>
        <Locations ref={ref} onSuccess={onSuccess} />
      </GoogleMapsProvider>
    </>
  );
});
LocationMap.displayName = 'LocationMap';
export default LocationMap;
